<template>
    <div class="wrap">
         <div class="hd-bg">
            <div class="header">
                <div class="left"><a href="javascript:;" class="btn return" @click="$router.back()"></a></div>
                <div class="right"><a href="javascript:;" class="btn tel" @click="telConfirm"></a><a href="javascript:;" class="btn user" @click="checkLogined"></a></div>
                <div class="center"><router-link to="/">主力户型</router-link></div>
            </div>
        </div>
        <div class="p-card">
            <van-swipe @change="onChange">
                <van-swipe-item>
                    <img src="../assets/images/typedetail.png" alt="">
                </van-swipe-item>
                <van-swipe-item>

                </van-swipe-item>
                <template #indicator>
                    <div class="custom-indicator">
                    {{ current + 1 }}/2
                    </div>
                </template>
                </van-swipe>
        </div>
        <div class="inner-wrap">
            <div class="main-content">
                <div class="main-wrap">
                   <div class="h-title">
                        <h1>北京经开壹中心</h1>
                        <div class="status">在售</div>
                   </div>
                    <ul class="itemdesc-wrap">
                       <li class="price-wrap">
                           <div class="label price">租售价格</div>
                            <div class="content"><span class="big">27000</span><span>元/平方米</span></div>
                        </li>
                        <li class="two-desc">
                            <div class="left">
                                <span class="inner-label">户型结构</span>
                                <span>暂无</span>
                            </div>
                            <div class="right">
                                <span class="inner-label">朝&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;向</span>
                                <span>暂无</span>
                            </div>
                        </li> 
                        <li class="two-desc">
                            <div class="left">
                                <span class="inner-label">建筑面积</span>
                                <span>2000m²</span>
                            </div>
                            <div class="right">
                                <span class="inner-label">使用面积</span>
                                <span>暂无</span>
                            </div>
                        </li> 
                        <li>
                            <div class="label">所属楼盘</div>
                            <div class="content address">北京市-大兴区 北京经开·壹中心</div>
                        </li>
                        <li>
                            <div class="label">开发商</div>
                            <div class="content">北京经开投资开发股份有限公司</div>
                        </li>
                    </ul>
                    <div class="user-wrap">
                        <div class="left">
                            <div>拨打电话免费咨询</div>
                            <div>400-0080-960转14228</div>
                        </div>
                        <div class="right">
                            <div class="inner-left"></div>
                            <div class="inner-right">
                                <div>
                                    <span class="name">陈思成</span>
                                    <span>选址顾问</span>
                                </div>
                                <div>
                                    大兴区选址顾问
                                </div>
                                <div class="introduence">
                                    咨询
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="house-type">
                        <div class="title">
                            <div class="left">本项目其他户型（12）</div>
                            <div class="right"><span>查看更多</span><van-icon name="arrow" /></div>
                        </div>
                        <div gutter="80" class="photos" type="flex" justify="space-between">
                            <div class="item" span="8">
                                <div class="inner">
                                     <img src="../assets/images/typedetail.png" alt="">
                                </div>
                                <div class="in-title">标题</div>
                                <div class="in-subtitle">建筑面积约2000平米</div>
                                <div class="in-status">状态</div>
                            </div>
                            <div class="item" span="8">
                                <div class="inner">
                                     <img src="../assets/images/typedetail.png" alt="">
                                </div>
                                <div class="in-title">标题</div>
                                <div class="in-subtitle">副标题</div>
                                <div class="in-status">状态</div>
                            </div>
                            <div class="item" span="8">
                                <div class="inner">
                                     <img src="../assets/images/typedetail.png" alt="">
                                </div>
                                <div class="in-title">标题</div>
                                <div class="in-subtitle">副标题</div>
                                <div class="in-status">状态</div>
                            </div>
                        </div>
                    </div>
                            <div class="tuijian">
           <div class="top">
               <div class="title">
                        楼盘推荐
                </div>
                <div class="more"><span>查看更多</span><van-icon name="arrow" /></div>
           </div>
           <div class="fang-wrap">
               <div class="left">

               </div>
               <div class="right">
                    <div class="status-wrap">
                        <div class="status">在租</div>
                        <div class="title">南昌高新产业园区</div>
                    </div>
                    <div>
                        <span class="place">北京</span>
                        <span class="location">大兴区</span>
                    </div>
                    <div class="price">
                        <span class="big">2.3</span>
                        <span>元/平方米/天</span>
                    </div>
                    <div class="btn-group">
                        <div class="item">
                            产业园
                        </div>
                        <div class="item">
                            可出租
                        </div>
                    </div>
               </div>
           </div>
           <div class="fang-wrap">
               <div class="left">

               </div>
               <div class="right">
                    <div class="status-wrap">
                        <div class="status">在租</div>
                        <div class="title">南昌高新产业园区</div>
                    </div>
                    <div>
                        <span class="place">北京</span>
                        <span class="location">大兴区</span>
                    </div>
                    <div class="price">
                        <span class="big">2.3</span>
                        <span>元/平方米/天</span>
                    </div>
                    <div class="btn-group">
                        <div class="item">
                            产业园
                        </div>
                        <div class="item">
                            可出租
                        </div>
                    </div>
               </div>
           </div>
           <div class="fang-wrap">
               <div class="left">

               </div>
               <div class="right">
                    <div class="status-wrap">
                        <div class="status">在租</div>
                        <div class="title">南昌高新产业园区</div>
                    </div>
                    <div>
                        <span class="place">北京</span>
                        <span class="location">大兴区</span>
                    </div>
                    <div class="price">
                        <span class="big">2.3</span>
                        <span>元/平方米/天</span>
                    </div>
                    <div class="btn-group">
                        <div class="item">
                            产业园
                        </div>
                        <div class="item">
                            可出租
                        </div>
                    </div>
               </div>
           </div>
        </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { Swipe, SwipeItem,Icon} from 'vant'
    
    export default {
        name: "photosview",
        data: function(){
            return {
                current:0
                
            }
        },
        components: {
            Header, Footer,
            [Icon.name]:Icon,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem
        },
        mounted(){
           
        },
        methods: {
            onChange(index) {
                this.current = index;
            },
            checkLogined () {
                var _this = this;
                _this.api.getUserInfo().then(function(response){
                    if (response.status == 1) {
                        _this.$router.push('UserCenter')
                    } else {
                        _this.$router.push('Login')
                    }
                })
            },
            telConfirm () {
                Dialog.confirm({
                    title: '400转接',
                    message: '',
                    confirmButtonText: '确定'
                }).then(() => {
                    window.location.href = "tel:4000080960";
                }).catch(()=>{});
            }
        }
    }
</script>
<style scoped lang="scss">
@import "./common.scss";
.fang-wrap .price{
        color:#ff0100;
    }
    .fang-wrap .big{
        font-size:px2rem(15px);
        font-weight:bold;
    }
    .fang-wrap .btn-group{
        display:flex;
        align-items: center;
    }
     .fang-wrap .btn-group .item{
       color:#336094;
       border:px2rem(1px) solid #336094;
        margin-right:px2rem(4px);
height:px2rem(16px);
display:flex;
align-items: center;
padding:0 px2rem(5px)
    }
.fang-wrap .place{
        margin-right:px2rem(6px);
    }
    .fang-wrap .status-wrap{
        display:flex;
        align-items: center;
    }
    .fang-wrap .title{
        font-size:px2rem(14px)!important;
        font-weight:bold;
    }
    .fang-wrap .status{
        background:#fe0000;
        height:px2rem(16px);
        margin-right:px2rem(4px);
        display:flex;
        align-items: center;
        padding:0 px2rem(5px);
        color:#fff;
    }
    .fang-wrap{
        display:flex;
        margin-bottom:px2rem(8px);
    }
    .fang-wrap .left{
        margin-top:px2rem(1.8px);
        margin-right:px2rem(6px);
        width:px2rem(73px);
        height:px2rem(73px);
        background:red;
        border-radius:px2rem(3px);
    }
    .fang-wrap .left img{
        width:px2rem(73px);
        height:px2rem(73px);
    }
.tuijian .title{
        font-size:px2rem(16px);
    }
    .tuijian .more{
        color:#9a9da1;
        display:flex;
        align-items: center;
    }
    .tuijian .top{
        display:flex;
        padding-bottom:px2rem(14px);
        justify-content: space-between;
    }
    .tuijian{
        margin-top:px2rem(10px);
        padding:px2rem(16px) px2rem(14px);
    }
    .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 2px 12px;
        border-radius:34px;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.8);
        color:#fff;
    }
     .hd-bg {height: 1rem;}

    .header {
        position: fixed;top: 0;left: 0;width: 100%;height: 1rem;z-index: 100;
        background-color: #343434;line-height: 1rem;text-align: center;
    }
    .header .btn {
        display: inline-block;vertical-align: middle;width: .36rem;height: .36rem;margin: 0 .15rem;
        background-repeat: no-repeat;background-position: center center;-webkit-background-size: contain;background-size: contain;
    }
    .header .return {background-image: url('../assets/images/icon-return.png');}
    .header .user {background-image: url('../assets/images/icon-head-user.png');}
    .header .tel {background-image: url('../assets/images/icon-head-tel.png');}
    .header .left {
        position: absolute;top: 0;left: .15rem;
    }
    .header .right {
        position: absolute;top: 0;right: .15rem;
    }
    .header .center {
        position: relative;
        display: inline-block;
        font-size: .36rem;color: #ffffff;
    }
    .header .city {
        position: absolute;left: 100%;top: 50%;margin: -.7em .1rem 0;
        white-space: nowrap;font-size: .6em;line-height: 2;
        padding-right: .2rem;background: url("../assets/images/icon-sel3.png") no-repeat right center;-webkit-background-size: .15rem;background-size: .15rem;
    }
    #map{
        height:px2rem(100px);
        background:red;
    }
    .house-type .in-status{
        background:#ff0000;
        color:#fff;
        width:px2rem(20px);
        display:flex;
        justify-content: center;
        font-size:px2rem(8px); 
    }
    .house-type .in-subtitle{
        color:#888d90;
        font-size:px2rem(10px);
    }
    .house-type .inner img{
       width:100%;
       height:100%;
       display:block;
    }
    .house-type .inner{
        border:px2rem(1px) solid #e6e6e6;
        padding:0 px2rem(6px);
    }
    .house-type .photos{
        display:flex;
        justify-content: space-around;
    }
    .house-type .photos .item{
       
        width:31%;
    }
    .house-type{
        padding:0 px2rem(13px) px2rem(16px) px2rem(13px);
    }
    .house-type .title .right{
        color:#95999c;
        position:relative;
        display:flex;
        align-items: center;
        top:px2rem(14px);
    }
    .house-type .title .left{
        font-size:px2rem(14px);
        color:#333;
        margin-top:px2rem(20px);
    }
    .house-type .title{
       display:flex;
       justify-content: space-between;
       padding-bottom:px2rem(12px);
    }
    .user-wrap .name{
        font-size:px2rem(11px);
        padding-right:px2rem(4px);
        font-weight:bold;
    }
    .user-wrap .introduence{
        background:url(../assets/images/message.png)#d30000 no-repeat px2rem(4px) px2rem(2.2px) ;
        background-size:px2rem(8.2px) auto;
        color:#fff;
        padding-left:px2rem(15px);
        font-size:px2rem(8px);
        width:px2rem(38px);
    }
   .user-wrap .inner-right{
        padding-left:px2rem(4px);
        padding-right:px2rem(4px);
    }
    .user-wrap .right{
        font-size:px2rem(8px);
        display:flex;
        align-items: center;
        justify-content: space-between;
    }
    .user-wrap .inner-left{
        border-radius:50%;
        width:px2rem(40px);
        height:px2rem(40px);
        background:red;
    }
    .user-wrap .left{
        padding:px2rem(8px) px2rem(4px) px2rem(6px) px2rem(20px);
    }
    .user-wrap{
        background:#efd6af;
        padding:px2rem(4px) 0;
        display:flex;
        justify-content: space-between;
    }
    .itemdesc-wrap .inner-label{
        color:#888d90;
        padding-right:px2rem(6px)
    }
    .itemdesc-wrap .two-desc div{
        flex:1;
    }
    .itemdesc-wrap .two-desc{
        justify-content: space-between;
    }
    .itemdesc-wrap .address{
        color:#2f6095;
    }
    .itemdesc-wrap .big{
        color:#ff0000;
        font-size:px2rem(15px);
    }
    .itemdesc-wrap .price-wrap{
        margin-bottom:px2rem(8px)
    }
    .itemdesc-wrap .price{
        font-size:px2rem(15px);
        
        width:px2rem(63px)!important;
    }
    .itemdesc-wrap li{
        align-items: center;
        height:px2rem(18px);
        display:flex;
    }
     .itemdesc-wrap .label{
        display:flex;
        width:px2rem(48px);
        color:#7e8386;
    }
    .itemdesc-wrap{
        padding:px2rem(14px) px2rem(13px);
    }
     .shuzimeiti{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        margin-left:px2rem(3px);
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#6da2eb;
    }
    .h-title{
        
        display:flex;
        align-items: center;
        padding-left:px2rem(13px);
        padding-right:px2rem(13px);
        padding-top:px2rem(12px);
    }
    .h-title .status{
        margin-left:px2rem(6px);
        height:px2rem(14px);
        color:#fff;
        width:px2rem(28px);
        color:#fff;
        background:#ff0000;
        display:flex;
        justify-content: center;
        align-items: center;
        border-radius:px2rem(2px);
    }
    h1{
        font-weight:bold;
        font-size:px2rem(14px);

    }
    .wrap{
        background:#fafafa;
    }
   .p-card{
       height:px2rem(200px);
   }
   .p-card img{
       height:px2rem(200px);
       margin:0 auto;
       display:block;
   }
   .p-card .van-swipe{
       height:100%;
   }
   .inner-wrap{
       padding:0 px2rem(9px);
   }
   .main-content{
       min-height:px2rem(200px);
   }
</style>